import { createSlice } from '@reduxjs/toolkit';

interface ImageSizeState {
  width: number;
  height: number;
}

const initialState: ImageSizeState = {
  width: 0,
  height: 0,
};

export const imageSizeSlice = createSlice({
  name: 'imageSize',
  initialState,
  reducers: {
    setWidth: (state, action) => {
      state.width = action.payload;
    },
    setHeight: (state, action) => {
      state.height = action.payload;
    },
    initImageSize: () => {
      return initialState;
    },
  },
});

export const { setWidth, setHeight, initImageSize } = imageSizeSlice.actions;

export default imageSizeSlice.reducer;
